import * as actionTypes from "../actionTypes";

export function setCurrentSession(sessionId) {
  return { type: actionTypes.SET_CURRENT_SESSION, data: sessionId };
}

export function addSession(session) {
  return { type: actionTypes.ADD_SESSION, data: session };
}

export function updateSession(updateData) {
  return { type: actionTypes.UPDATE_SESSION, data: updateData };
}

export function updateSessionViewports(sessionId, viewports) {
  return { type: actionTypes.UPDATE_SESSION_VIEWPORTS, data: {sessionId, viewports} };
}

export function removeSession(sessionId) {
  return { type: actionTypes.REMOVE_SESSION, data: sessionId };
}

export function clearSessions() {
  return { type: actionTypes.CLEAR_SESSIONS };
}

